import "../ReportContent/reportContent.css";

export default function ReportData({ reportHeader }) {
  return (
    <div>
      {reportHeader ? (
        reportHeader.map((item, index) => (
          <div className="content" key={index}>
        
            {index === 0 || item?.category !== reportHeader[index - 1]?.category ? (
              <div>
                <div className="category-name"><p>{item?.category}</p></div>
                <p>{item?.property}: {item?.reportData}</p>
              </div>
            ) : (
              <p>{item?.property}: {item?.reportData}</p>
            )}
          
          </div>
        ))
      ) : (
        <p>No report data available.</p>
      )}
    </div>
  );
}
